import AppHost from "../common/AppHost";
import MDBox from "../components/MDBox";
import PageLayout from "../layouts/dashboards";
import ErrorComponent from "./ErrorCard";

const ErrorPage = () => {
  return (
    <>
      <PageLayout padding={3} isAuthenticated={true}>
        <MDBox pt={5}>
          <ErrorComponent variant={2} showLogin={false} />
        </MDBox>
      </PageLayout>
    </>
  );
};

export default ErrorPage;
